import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import { MobilityMapService, TransportationTypeOrderingEnum } from '@ui/shared/util-api';
import type { MobilityMapFilterKey } from '../../types/mobility-map-filters';

@Injectable({ providedIn: 'root' })
export class TransportationTypeSelectFilterConfigService extends FilterConfigService<MobilityMapFilterKey, MobilityMapService> {
    public override type = 'multiselect' as const;

    constructor() {
        super(
            new MultiFilterModel('transportationTypes', 'Verkehrsmittel', []),
            inject(MobilityMapService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllTransportationTypes({
            order: [TransportationTypeOrderingEnum.Name],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
